import {listSubscription} from "../api/api-billing"
import {isEmpty} from "lodash/lang"
import {head} from "lodash/array"

class SubscriptionManager {
  constructor() {
    this.isSubscriptionEmpty = true
    this.subscription = null
    this.subscriptionPlan = null
    this.subscriptionPlanConfig = null

    this.hasError = false
  }

  async getSubscription(authToken) {
    return listSubscription(authToken)
      .then(res => {
        const subscriptions = res.data.data
        if (isEmpty(subscriptions)) {
          this.isSubscriptionEmpty = true
          return
        }
        this.isSubscriptionEmpty = false
        this.subscription = head(subscriptions)
        this.subscriptionPlan = this.subscription["subscription_plan"]
        this.subscriptionPlanConfig = this.subscriptionPlan["subscription_plan_configuration"]
      }).catch(() => {
        this.hasError = true
      })
  }
}

export default () => {
  return new SubscriptionManager()
}
